import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

const BasicForm = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Forms Input" pageType="Forms" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Input Text
            </h2>
            <form className="space-y-4">
              <input
                type="text"
                className="form-input"
                placeholder="Username"
                required
              />
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Email Text
            </h2>
            <form className="space-y-4">
              <input
                type="email"
                className="form-input"
                placeholder="Email Type"
                required
              />
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Lable Text
            </h2>
            <form className="space-y-4">
              <div className="space-y-2">
                <label>Type Username:</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Username"
                  required
                />
              </div>
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Password Input
            </h2>
            <form className="space-y-4">
              <input
                type="password"
                className="form-input"
                placeholder="Type Password"
                required
              />
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Url Input
            </h2>
            <form className="space-y-4">
              <input
                type="url"
                className="form-input"
                placeholder="https://dummyurl.com"
                required
              />
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Search Input
            </h2>
            <form className="space-y-4">
              <input
                type="search"
                className="form-input"
                placeholder="Search..."
                required
              />
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Telephone Input
            </h2>
            <form className="space-y-4">
              <input
                type="tel"
                className="form-input"
                placeholder="0-(000)-111-1111"
                required
              />
              <button type="submit" className="btn bg-purple border-purple text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Rounded Input
            </h2>
            <form className="space-y-4">
              <input
                type="text"
                className="rounded-full form-input"
                placeholder="Type Username"
                required
              />
              <button type="submit" className="btn bg-purple border-purple rounded-full text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]">Submit</button>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Fields Size
            </h2>
            <form className="space-y-4">
              <div className="space-y-2">
                <label>Large Input</label>
                <input
                  type="text"
                  className="form-input h-14"
                  placeholder="Username"
                  required
                />
              </div>
              <div className="space-y-2">
                <label>Default Input</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Username"
                  required
                />
              </div>
              <div className="space-y-2">
                <label>Small Input</label>
                <input
                  type="text"
                  className="h-10 form-input"
                  placeholder="Username"
                  required
                />
              </div>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Fields Size
            </h2>
            <form className="space-y-4">
              <div className="items-center justify-between gap-4 space-y-2 sm:flex">
                <label className="w-24 shrink-0">Large Input</label>
                <input
                  type="text"
                  className="form-input h-14"
                  placeholder="Username"
                  required
                />
              </div>
              <div className="items-center justify-between gap-4 space-y-2 sm:flex">
                <label className="w-24 shrink-0">Default Input</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Username"
                  required
                />
              </div>
              <div className="items-center justify-between gap-4 space-y-2 sm:flex">
                <label className="w-24 shrink-0">Small Input</label>
                <input
                  type="text"
                  className="h-10 form-input"
                  placeholder="Username"
                  required
                />
              </div>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Select Menu
            </h2>
            <form>
              <select className="form-select">
                <option>Select Option</option>
                <option>One</option>
                <option>Two</option>
                <option>Three</option>
              </select>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Select Menu
            </h2>
            <form>
              <select size={4} multiple className="h-auto form-multiselect">
                <option>Select menu</option>
                <option>One</option>
                <option>Two</option>
                <option>Three</option>
                <option>Four</option>
                <option>Five</option>
                <option>Six</option>
              </select>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Checkbox
            </h2>
            <form className="space-y-4">
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" className="form-checkbox" defaultChecked />
                <span>Checkbox</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" className="form-checkbox" defaultChecked />
                <span>Checkbox</span>
              </label>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio
            </h2>
            <form className="space-y-4">
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="radio-one"
                  className="rounded-full form-radio"
                  defaultChecked
                />
                <span>One</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="radio-one"
                  className="rounded-full form-radio"
                />
                <span>Two</span>
              </label>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              disabled Radio & Checkbox
            </h2>
            <form className="space-y-4">
              <label className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="radio-one"
                  disabled
                  className="rounded-full form-radio"
                  defaultChecked
                />
                <span>One</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  disabled
                  defaultChecked
                />
                <span>Checkbox</span>
              </label>
            </form>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              disabled Input
            </h2>
            <form className="space-y-4">
              <input
                type="text"
                className="cursor-not-allowed form-input"
                placeholder="Username"
                required
                disabled
              />
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicForm;
